import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { toolbarMessages } from '@atlaskit/editor-common/messages';
import { useEditorToolbar } from '@atlaskit/editor-common/toolbar';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { ToolbarDropdownMenu, ToolbarTooltip, TextIcon } from '@atlaskit/editor-toolbar';
import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { toolbarBlockTypesWithRank } from '../../block-types';
var usePluginState = conditionalHooksFactory(function () {
  return expValEquals('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true);
}, function (api) {
  return useSharedPluginStateWithSelector(api, ['blockType'], function (state) {
    var _state$blockTypeState, _state$blockTypeState2;
    return {
      blockTypesDisabled: (_state$blockTypeState = state.blockTypeState) === null || _state$blockTypeState === void 0 ? void 0 : _state$blockTypeState.blockTypesDisabled,
      currentBlockType: (_state$blockTypeState2 = state.blockTypeState) === null || _state$blockTypeState2 === void 0 ? void 0 : _state$blockTypeState2.currentBlockType
    };
  });
}, function (api) {
  var blockTypesDisabled = useSharedPluginStateSelector(api, 'blockType.blockTypesDisabled');
  var currentBlockType = useSharedPluginStateSelector(api, 'blockType.currentBlockType');
  return {
    blockTypesDisabled: blockTypesDisabled,
    currentBlockType: currentBlockType
  };
});
export var TextStylesMenuButton = function TextStylesMenuButton(_ref) {
  var _Object$values$find;
  var api = _ref.api,
    children = _ref.children;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _usePluginState = usePluginState(api),
    blockTypesDisabled = _usePluginState.blockTypesDisabled,
    currentBlockType = _usePluginState.currentBlockType;
  var blockTypes = toolbarBlockTypesWithRank();
  var _useEditorToolbar = useEditorToolbar(),
    editorAppearance = _useEditorToolbar.editorAppearance;
  var CurrentIcon = (_Object$values$find = Object.values(blockTypes).find(function (blockType) {
    return blockType.name === (currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name);
  })) === null || _Object$values$find === void 0 || (_Object$values$find = _Object$values$find.icon) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.type;
  var normalText = blockTypes.normal;
  var TriggerIcon = useMemo(function () {
    if (editorAppearance === 'full-page') {
      var hasCurrentBlockType = currentBlockType && CurrentIcon;
      var Icon = hasCurrentBlockType ? CurrentIcon : TextIcon;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        label: "",
        size: "small"
      }), hasCurrentBlockType ? formatMessage(currentBlockType.title) : formatMessage(normalText.title));
    }
    return CurrentIcon ? /*#__PURE__*/React.createElement(CurrentIcon, {
      label: "".concat(currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name, " ").concat(formatMessage(toolbarMessages.textStylesTooltip)),
      size: "small"
    }) : /*#__PURE__*/React.createElement(TextIcon, {
      label: formatMessage(toolbarMessages.textStylesTooltip),
      size: "small"
    });
  }, [editorAppearance, currentBlockType, CurrentIcon, normalText, formatMessage]);
  return /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: formatMessage(toolbarMessages.textStylesTooltip)
  }, /*#__PURE__*/React.createElement(ToolbarDropdownMenu, {
    isDisabled: blockTypesDisabled,
    iconBefore: TriggerIcon
  }, children));
};